export const GrabbingStoppedMessage = 'grabbingStoppedMessage';
export const GrabbingDoneMessage = 'grabbingDoneMessage';
export const StartEntirePageGrabMessage = 'startEntirePageGrabMessage';
export const PdfRotationMessage = 'pdfRotationMessage';
export const DoneRenderingPdfMessage = 'doneRenderingPdfMessage';
export const CurrentPageMessage = 'currentPageMessage';
export const AllPagesMessage = 'allPagesMessage';
export const PagesInBetweenMessage = 'pagesInBetweenMessage';
